import * as formatUtils from "./formatUtils";
import { CODIGOS_GRUPO_PRODUCTOS_PAGO_NO_SOPORTADOS } from "../infrastructure/appConstants";
import { tipoDocumentoOptions } from "../config/data/options";

export const createOptionsGeneric = (objects, fieldText, fieldValue) => {
  if (objects) {
    let options = objects.map((object, index) => ({
      key: index,
      text: object[fieldText],
      value: object[fieldValue],
    }));
    return options;
  }
};

export const createOptionsPrestamos = (prestamos) => {
  let options = [];
  if (prestamos && prestamos.length > 0) {
    const prestamosFiltrados = prestamos.filter(
      (p) =>
        !CODIGOS_GRUPO_PRODUCTOS_PAGO_NO_SOPORTADOS.includes(
          String(p.codigoGrupoProducto).trim()
        )
    );
    if (prestamosFiltrados.length > 0) {
      options = prestamosFiltrados.map((prestamo, index) => ({
        key: index,
        text: `${prestamo.credito} - ${
          prestamo.nombreMoneda
        } ${formatUtils.formatMoney(prestamo.importe)}`,
        value: prestamo.credito,
      }));
    }
  }
  return options;
};

export const createOptionsCuentaAperturarCargo = (cuentas) => {
  let options = [];
  if (cuentas && cuentas.length > 0) {
    if (cuentas.length > 0) {
      options = cuentas.map((cuenta, index) => ({
        key: index,
        text: `${cuenta.numeroCuenta} - ${
          cuenta.nombreMoneda
        } ${formatUtils.formatMoney(cuenta.saldoDisponible)}`,
        value: cuenta.numeroCuenta,
      }));
    }
  }
  return options;
};

export const createOptionsCronogramas = (cronogramas) => {
  if (cronogramas) {
    return cronogramas.map((cronograma, index) => ({
      key: index,
      text: `Cronograma: ${cronograma}`,
      value: cronograma,
    }));
  }
};

export const createOptionsTelefonosAfiliacion = (telefonos) => {
  if (telefonos) {
    return telefonos.map((telefono, index) => ({
      key: index,
      text: `${telefono}`,
      value: telefono,
    }));
  }
};

export const createOptionsCuentaTransferencias = (cuentas) => {
  let options = [];
  if (cuentas && cuentas.length > 0) {
    options = cuentas.map((cuenta, index) => ({
      key: index,
      text: `${cuenta.numeroCuenta} - ${
        cuenta.nombreMoneda
      } ${formatUtils.formatMoney(cuenta.saldoDisponible)}`,
      value: cuenta.numeroCuenta,
    }));
  }
  return options;
};

export const createOptionsBancosTransferencias = (bancos) => {
  let options = [];
  if (bancos && bancos.length > 0) {
    options = bancos.map((banco, index) => ({
      key: index,
      text: banco.nombre,
      value: banco.codigo,
    }));
  }
  return options;
};

export const createOptionsTipoCuentasPorBancoTransferencia = (banco) => {
  let options = [];
  if (banco && banco.tiposCuentas && banco.tiposCuentas.length > 0) {
    options = banco.tiposCuentas.map((tipoCuenta, index) => ({
      key: index,
      text: tipoCuenta.descripcion,
      value: tipoCuenta.codigo,
    }));
  }
  return options;
};

export const TYPE_OPTIONS_TIPO_DOCUMENTO_IDENTIDAD = "2";

export const getTextOption = (value, type) => {
  switch (type) {
    case TYPE_OPTIONS_TIPO_DOCUMENTO_IDENTIDAD:
      return tipoDocumentoOptions.filter((t) => t.value === value)[0].text;
    default:
      return "";
  }
};

export const createOptionsCuentaPagos = (cuentas, codigoMoneda) => {
  let options = [];
  if (codigoMoneda && cuentas && cuentas.length > 0) {
    const filtrados = cuentas.filter((c) => codigoMoneda === c.codigoMoneda);
    if (filtrados.length > 0) {
      options = filtrados.map((cuenta, index) => ({
        key: index,
        text: `${cuenta.numeroCuenta} - ${
          cuenta.nombreMoneda
        } ${formatUtils.formatMoney(cuenta.saldoDisponible)}`,
        value: cuenta.numeroCuenta,
      }));
    }
  }
  return options;
};

export const createOptionsProductosCuenta = (
  productosCuenta,
  codigoMoneda,
  tipoPersona
) => {
  let options = [];
  if (codigoMoneda && productosCuenta && productosCuenta.length > 0) {
    const filtrados = productosCuenta.filter(
      (c) => codigoMoneda === c.codigoMoneda && tipoPersona === c.tipoPersona
    );
    if (filtrados.length > 0) {
      options = filtrados.map((productoCuenta, index) => ({
        key: index,
        text: productoCuenta.descripcion,
        value: productoCuenta.producto,
      }));
    }
  }
  return options;
};
